import {
  IonAccordion,
  IonAccordionGroup,
  IonItem,
  IonLabel,
} from '@ionic/react'

import type { Children, PropsWithChildren } from '../../types'

function AccordionGroup({ children }: Children) {
  return <IonAccordionGroup className="pl-5">{children}</IonAccordionGroup>
}

function Accordion({ children, value }: PropsWithChildren<{ value: string }>) {
  return (
    <IonAccordion className="border-ion-color-step-600 border-b " value={value}>
      {children}
    </IonAccordion>
  )
}

function AccordionItem({ label }: { label: string }) {
  return (
    <IonItem style={{ '--padding-start': 0 }} slot="header" color="secondary">
      <IonLabel>{label}</IonLabel>
    </IonItem>
  )
}

function AccordionContent({ children }: { children: React.ReactNode }) {
  return (
    <div
      slot="content"
      className="bg-ion-color-secondary text-ion-color-primary ion-padding-horizontal ion-padding-bottom"
    >
      {children}
    </div>
  )
}

export { Accordion, AccordionContent, AccordionGroup, AccordionItem }
